import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnDestroy } from "@angular/core"
import { Subject, takeUntil } from "rxjs"
import { PermissionService } from "../services/permission.service"

@Directive({
  selector: "[hasRole]",
  standalone: true,
})
export class HasRoleDirective implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>()
  private requiredRoles: string[] = []

  @Input() set hasRole(roles: string | string[]) {
    this.requiredRoles = Array.isArray(roles) ? roles : [roles]
    this.updateView()
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService,
  ) {}

  ngOnInit() {
    this.permissionService.currentRole$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.updateView()
    })
  }

  ngOnDestroy() {
    this.destroy$.next()
    this.destroy$.complete()
  }

private updateView() {
  this.viewContainer.clear();   // 🔑 clear existing view first

  const hasRole = this.permissionService.hasAnyRole(this.requiredRoles);

  if (hasRole) {
    this.viewContainer.createEmbeddedView(this.templateRef);
  }
}
}
